(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .service('ShipmentDocumentCustomService',ShipmentDocumentCustomService);

    ShipmentDocumentCustomService.$inject = ['$http'];

    function ShipmentDocumentCustomService($http) {
        return {
            getShipmentDocumentByShipmentId: getShipmentDocumentByShipmentId
        }

        function getShipmentDocumentByShipmentId(id) {
            var url = "api/shipment-document/shipment/" + id;
            return $http.get(url);
        }
    }
})();
